// 性別
export const GENDER_OPTIONS = [
  {
    name: '男性',
    value: '男性'
  },
  {
    name: '女性',
    value: '女性'
  },
  {
    name: 'その他',
    value: 'その他'
  },
  {
    name: '回答しない',
    value: '回答しない'
  }
]

// 47都道府県
export const PREF_OPTIONS = [
  {
    name: '北海道',
    value: '北海道'
  },
  {
    name: '青森県',
    value: '青森県'
  },
  {
    name: '岩手県',
    value: '岩手県'
  },
  {
    name: '宮城県',
    value: '宮城県'
  },
  {
    name: '秋田県',
    value: '秋田県'
  },
  {
    name: '山形県',
    value: '山形県'
  },
  {
    name: '福島県',
    value: '福島県'
  },
  {
    name: '茨城県',
    value: '茨城県'
  },
  {
    name: '栃木県',
    value: '栃木県'
  },
  {
    name: '群馬県',
    value: '群馬県'
  },
  {
    name: '埼玉県',
    value: '埼玉県'
  },
  {
    name: '千葉県',
    value: '千葉県'
  },
  {
    name: '東京都',
    value: '東京都'
  },
  {
    name: '神奈川県',
    value: '神奈川県'
  },
  {
    name: '新潟県',
    value: '新潟県'
  },
  {
    name: '富山県',
    value: '富山県'
  },
  {
    name: '石川県',
    value: '石川県'
  },
  {
    name: '福井県',
    value: '福井県'
  },
  {
    name: '山梨県',
    value: '山梨県'
  },
  {
    name: '長野県',
    value: '長野県'
  },
  {
    name: '岐阜県',
    value: '岐阜県'
  },
  {
    name: '静岡県',
    value: '静岡県'
  },
  {
    name: '愛知県',
    value: '愛知県'
  },
  {
    name: '三重県',
    value: '三重県'
  },
  {
    name: '滋賀県',
    value: '滋賀県'
  },
  {
    name: '京都府',
    value: '京都府'
  },
  {
    name: '大阪府',
    value: '大阪府'
  },
  {
    name: '兵庫県',
    value: '兵庫県'
  },
  {
    name: '奈良県',
    value: '奈良県'
  },
  {
    name: '和歌山県',
    value: '和歌山県'
  },
  {
    name: '鳥取県',
    value: '鳥取県'
  },
  {
    name: '島根県',
    value: '島根県'
  },
  {
    name: '岡山県',
    value: '岡山県'
  },
  {
    name: '広島県',
    value: '広島県'
  },
  {
    name: '山口県',
    value: '山口県'
  },
  {
    name: '徳島県',
    value: '徳島県'
  },
  {
    name: '香川県',
    value: '香川県'
  },
  {
    name: '愛媛県',
    value: '愛媛県'
  },
  {
    name: '高知県',
    value: '高知県'
  },
  {
    name: '福岡県',
    value: '福岡県'
  },
  {
    name: '佐賀県',
    value: '佐賀県'
  },
  {
    name: '長崎県',
    value: '長崎県'
  },
  {
    name: '熊本県',
    value: '熊本県'
  },
  {
    name: '大分県',
    value: '大分県'
  },
  {
    name: '宮崎県',
    value: '宮崎県'
  },
  {
    name: '鹿児島県',
    value: '鹿児島県'
  },
  {
    name: '沖縄県',
    value: '沖縄県'
  }
]